import React from 'react';

const Message = ({text}) => {
    return (
        <div className='messages-message'>
          
        </div>
    )
}

export default Message;


// WEBPACK FOOTER //
// ./src/components/chat/Message.js